import React from "react";
import { ArrowRight, Link as LinkIcon, FileText } from "lucide-react";
import { Link } from "@/components/common/Link";
import { cn } from "@/lib/utils";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const resourceCategories = [{
  title: "[PLATZHALTER: Kategorie 1 - z.B. Partner & Verbände]",
  icon: <LinkIcon className="w-5 h-5" />,
  links: [{
    title: "[PLATZHALTER: Bundesinnungsverband des Gebäudereiniger-Handwerks]",
    url: "#"
  }, {
    title: "[PLATZHALTER: IHK Regional]",
    url: "#"
  }, {
    title: "[PLATZHALTER: TÜV Süd - Aufzugstechnik]",
    url: "#"
  }, {
    title: "[PLATZHALTER: Zertifizierungsstelle XYZ]",
    url: "#"
  }]
}, {
  title: "[PLATZHALTER: Kategorie 2 - z.B. Hersteller & Technik]",
  icon: <FileText className="w-5 h-5" />,
  links: [{
    title: "[PLATZHALTER: KONE Rolltreppen]",
    url: "#"
  }, {
    title: "[PLATZHALTER: Schindler Aufzüge & Fahrtreppen]",
    url: "#"
  }, {
    title: "[PLATZHALTER: Otis Elevator Company]",
    url: "#"
  }, {
    title: "[PLATZHALTER: ThyssenKrupp Elevator]",
    url: "#"
  }]
}];
export default function ResourcesAndLinks() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return;
}